import React from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import SvgIcon from "../SvgIcon";

const ManageCategories = ({
  category,
  entity = "Programs",
  filteredItemsLength = 0,
  selectedCategoryIndex,
  selectedCategoryId,
  deleteCategory,
}) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <div className="manage-categories">
      <div className="category-title">
        <span className="title">{category}</span>
        <span className="sub-title">
          ({filteredItemsLength}) {entity}
        </span>
      </div>
      {!["Uncategorized", "all", "All"].includes(category) ? (
        <div className="buttons">
          <button
            className="button"
            data-button-type="secondary"
            data-icon
            onClick={() => {
              submit("/actions/refresh?", {
                method: "GET",
                body: {
                  "modal[type]": "manage-categories",
                  newCategory: false,
                  selectedCategoryId: selectedCategoryId,
                },
              });
            }}
          >
            <SvgIcon alt={t("manageCategories.manage")} src="/img/new-icons/manage.svg" />
            {t("manageCategories.manage")}
          </button>
          <button
            data-button-type="secondary"
            data-action="cancel"
            data-icon
            onClick={() => deleteCategory(selectedCategoryIndex)}
          >
            <SvgIcon
              className="icon-white"
              alt={t("common:delete")}
              src="/img/new-icons/red-trash.svg"
            />
            {t("manageCategories.deleteCategory")}
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default ManageCategories;
